import { Check, Phone } from "lucide-react";

const points = [
  "Clear project walkthroughs before work starts",
  "Labor-only or full-scope estimates available",
  "Respectful jobsite protection and daily cleanup",
  "Serving Niagara Falls, Buffalo, Lockport and WNY",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-brand-bone"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <p className="eyebrow">About Artisan Contracting</p>
          <h2 className="section-title mt-3">
            Local, detail-focused, and built on{" "}
            <span className="text-brand-rust">clean finish work.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-brand-sub leading-relaxed max-w-xl">
            Artisan Contracting helps homeowners improve the inside of their
            homes with honest communication, careful prep, and professional
            finish work. We focus on interior projects where the details matter.
          </p>

          <ul className="mt-8 space-y-3">
            {points.map((p, i) => (
              <li
                key={p}
                data-testid={`about-point-${i}`}
                className="flex items-start gap-3 text-sm md:text-base text-brand-ink"
              >
                <span className="mt-1 h-5 w-5 flex-shrink-0 bg-brand-ink text-white flex items-center justify-center">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 inline-flex flex-col sm:flex-row gap-3">
            <a href="#contact" data-testid="about-estimate-button" className="btn-primary">
              Get a Free Estimate
            </a>
            <a
              href="tel:17165134765"
              data-testid="about-call-button"
              className="btn-outline"
            >
              <Phone className="h-4 w-4" /> 716-513-4765
            </a>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <div className="relative aspect-[4/5] overflow-hidden border border-brand-line">
            <img
              src="https://images.pexels.com/photos/8961339/pexels-photo-8961339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
              alt="Craftsman working on interior trim"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
          <div className="hidden md:flex absolute -left-6 -bottom-6 bg-brand-ink text-white p-6 w-64 flex-col gap-1 border border-brand-ink">
            <span className="font-display text-5xl font-black leading-none text-brand-rust">
              1yr
            </span>
            <span className="text-sm text-white/80">
              workmanship warranty on every interior project we complete.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
